import httpClient from "@/lib/http-client"
import { generateImagePath } from "@/lib/utils"
import qs from "qs"
import MediaUpload from "../(admin)/modules/media/pages/AddNewMedia"
import Media from "../(admin)/modules/media/pages/Media"
import DefaultImageFile from "../lib/config/assets/empty-img.jpg"

export interface FilterSearchParams {
  populate: string
  filters: {
    [key: string]: {
      $containsi?: string
      $null?: boolean
      $gt?: string
      $lt?: string
      $in?: string
      $eq?: string
    }
  }
  sort: string
  publicationState?: string
  pagination?: {
    page?: string
    pageSize?: string
    current?: string
    start?: string
    limit?: string
    total?: string
    withCount?: boolean
  }
  locale?: string
}

const fetchPostByCategories = async (categoriesId: string[]) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    publicationState: "live",
    filters: {
      categories: {
        // @ts-expect-error
        id: {
          $in: categoriesId,
        },
      },
    },
  }

  try {
    const response = await httpClient.get<any>(`posts?${qs.stringify(params, { encodeValuesOnly: true })}`)

    const modifiedResponse = response.data.map((post: any) => ({
      ...post,
      status: post.attributes.publishedAt ? "published" : "draft",
      publishedAt: post.attributes.publishedAt,
    }))

    return {
      data: modifiedResponse,
      meta: response.meta,
    }
  } catch (error) {}
}
const fetchPostId = async (id: number) => {
  try {
    const response = await httpClient.get<{ data: any }>(`posts/${id}?populate=*`)
    return response.data
  } catch (error) {
    console.error("Error fetching post by ID:", error)
    throw error
  }
}

export interface BaseSystem {
  id: string
  attributes: {
    name: string
    address: string
    hotline: string
  }
}

const fetchCategories = async (searchTerm?: string, populate?: string) => {
  const params: FilterSearchParams = {
    populate: populate ? "" : "*",
    sort: "createdAt:desc",
    filters: searchTerm
      ? {
          name: { $containsi: searchTerm },
        }
      : {},
  }
  return await httpClient.get(`cateogries`, {
    params,
  })
}

const fetchBaseSystems = async () => {
  const response = await httpClient.get<{ data: any }>(`base-systems?populate=*&sort=id:DESC`)
  return response.data
}

export const filterOption = (input: string, option?: { label: string; value: string }) =>
  normalizeText((option?.label ?? "").toLowerCase()).includes(normalizeText(input.toLowerCase()))

export const normalizeText = (text: string) => {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
}

const DefaultImage = DefaultImageFile.src

export { DefaultImage, fetchBaseSystems, fetchCategories, fetchPostByCategories, fetchPostId, Media, MediaUpload }

export const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>, imgURL?: string) => {
  const target = e.currentTarget
  target.onerror = null

  if (imgURL && imgURL.length > 0) {
    target.src = generateImagePath(imgURL, "original")
  } else {
    target.src = DefaultImage
  }
}
